var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"id":"timesheets","fluid":"","tag":"section"}},[_c('react-wrapper',{attrs:{"component":_vm.TimesheetUtilisationSummaryComponent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }